"use client";

import * as React from "react";
import { Label as LabelPrimitive } from "radix-ui";

import { cn } from "@/lib/utils";
import { labelTextClassName } from "@/components/ui/form-label-styles";

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn("flex items-center gap-2", labelTextClassName, className)}
      {...props}
    />
  );
}

export { Label };
